import { jsx as _jsx } from "react/jsx-runtime";
import { MeshStandardMaterial, Vector3 } from "three";
import { Sinusoid } from "../../../core/util/Sinusoid";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { Model, setMaterialRecursively, useModelTemplate } from "../../../core/util/useModel";
import { addVectors, makeTransform } from "../../../core/util/SpatialUtils";
import { WATER_CENTER } from "./Contact3DBackgroundObjects";
import { useUpdate } from "../../../core/util/UseUpdate";
import { usePoolFunction } from "../../util/UsePoolFunction";
const SCALE = 7;
const WAVE_HEIGHT = 0.15;
const HORIZONTAL_DRIFT_MAGNITUDE = 0.1;
export const Pool = () => {
    const frameStateRef = useRef({
        xFunction: new Sinusoid({
            numAxes: 3,
            periods: [0.33],
        }),
        zFunction: new Sinusoid({
            numAxes: 5,
            periods: [0.33],
        }),
        baseXZPositions: [],
        poolGeometry: undefined,
    });
    const poolTemplate = useModelTemplate('/models/water.glb');
    const poolModelRef = useRef(undefined);
    const materialRef = useRef(undefined);
    useEffect(() => {
        const newMaterial = new MeshStandardMaterial({
            color: 0xade2f0,
            roughness: 0.025,
            transparent: true,
            flatShading: true,
            opacity: 0.9,
        });
        materialRef.current = newMaterial;
        console.log(`Created material. poolModelRef.current: ${poolModelRef.current}`);
        if (poolModelRef.current !== undefined) {
            console.log('Assigning material');
            setMaterialRecursively(poolModelRef.current, materialRef.current);
        }
        return () => {
            newMaterial.dispose();
        };
    }, []);
    const initialTransform = useMemo(() => makeTransform({ position: addVectors(WATER_CENTER, new Vector3(0, 0, 0)), scale: new Vector3(SCALE, SCALE, SCALE) }), []);
    const baseFunction = usePoolFunction();
    useUpdate((state, deltaTime) => {
        const { poolGeometry, xFunction, zFunction, baseXZPositions, } = frameStateRef.current;
        if (poolGeometry !== undefined) {
            // Animate geometry
            const initializeBaseXZPositions = baseXZPositions.length === 0;
            xFunction.updateAxes(deltaTime);
            zFunction.updateAxes(deltaTime);
            const posAttribute = poolGeometry.attributes.position;
            const tempPosition = new Vector3();
            for (let i = 0; i < posAttribute.count; i++) {
                tempPosition.fromBufferAttribute(posAttribute, i);
                if (initializeBaseXZPositions) {
                    baseXZPositions.push(new Vector3(tempPosition.x, 0, tempPosition.z));
                }
                tempPosition.set(baseXZPositions[i].x + xFunction.sample(baseXZPositions[i].x, baseXZPositions[i].z) * HORIZONTAL_DRIFT_MAGNITUDE, 0, baseXZPositions[i].z + zFunction.sample(baseXZPositions[i].x, baseXZPositions[i].z) * HORIZONTAL_DRIFT_MAGNITUDE);
                posAttribute.setXYZ(i, tempPosition.x, (baseFunction(tempPosition.x * SCALE, tempPosition.z * SCALE) - 0.5) * WAVE_HEIGHT, tempPosition.z);
            }
            posAttribute.needsUpdate = true;
            poolGeometry.computeVertexNormals();
        }
    });
    const onCreateInstance = useCallback((model) => {
        frameStateRef.current.poolGeometry = model.children[0].geometry;
        console.log(`Created model. materialRef.current: ${materialRef.current}`);
        if (materialRef.current !== undefined) {
            console.log('Assigning material');
            setMaterialRecursively(model, materialRef.current);
        }
    }, []);
    return _jsx(Model, { template: poolTemplate, modelRef: poolModelRef, onCreateInstance: onCreateInstance, initialTransform: initialTransform });
};
//# sourceMappingURL=Pool.js.map